export default __webpack_public_path__ + "static/media/what-if-2.5f4caa2f.png";